module.exports = __webpack_public_path__ + "img/printer.b939e2ec.svg";